import { FetcherImpl } from './fetcher';
export * from './types';
export * from './utils';
export function createFetcher(requestCreatorOrURL, options) {
    if (typeof requestCreatorOrURL === 'string') {
        return new FetcherImpl((requestInit, context) => fetch(requestCreatorOrURL, Object.assign({}, requestInit, context)).then(
        // TODO: check content-type?
        (response) => response.json()), options);
    }
    return new FetcherImpl(requestCreatorOrURL, options);
}
